import {
    ModelFields,
    ModelField,
    isModelFieldType,
    isNonModelFieldType,
    isEnumFieldType,
} from "@aws-amplify/datastore";
import { schema } from "../models/schema";

/**
 * Get the type of a specific property on a model.
 * @param model Model to introspect
 * @param path Path to property to get the type for
 */
export function getType(model: string, path: string[]) {
    const field = getField(model, path);
    if (field) {
        return field.type;
    }
    return undefined;
}

export function getTypeName(field: ModelField) {
    if (isModelFieldType(field.type)) {
        //TODO: do we need to support this?
        return undefined;
    } else if (isNonModelFieldType(field.type)) {
        return (field.type as any)["nonModel"];
    } else if (isEnumFieldType(field.type)) {
        return (field.type as any)["enum"];
    }

    return field.type;
}

/**
 * Check that the passed object is correct for the object property
 * @param obj Object to check
 */
export function checkTypeIsCorrect(_model: string, _path: string[], _obj: any): boolean {
    return false;
}

export function getField(modelName: string, path: string[]): ModelField | undefined {
    const fields = getModelFields(modelName);
    if (fields) {
        const field = fields[path[0]];
        if (field) {
            if (path.length === 1) {
                return field;
            } else {
                const fieldModel = (field.type as any)["nonModel"] ?? (field.type as any)["model"];
                if (fieldModel) {
                    return getField(fieldModel, path.slice(1));
                }
            }
        }
    }
    return undefined;
}

export function getModelFields(modelName: string): ModelFields {
    let model: { fields: ModelFields } = schema.models[modelName];
    if (!model && schema.nonModels) {
        model = schema.nonModels[modelName];
    }
    return model.fields;
}
